module.exports = __webpack_public_path__ + "img/noData.e062a3bd.png";